import * as Layout1 from './Layout1/Layout1'
import * as Layout2 from './Layout2/Layout2'
import * as Layout3 from './Layout3/Layout3'
import * as Layout4 from './Layout4/Layout4'
import * as Layout5 from './Layout5/Layout5'
import * as Layout6 from './Layout6/Layout6'
import * as Layout7 from './Layout7/Layout7'

const LookbookBlock = {
  Layout1,
  Layout2,
  Layout3,
  Layout4,
  Layout5,
  Layout6,
  Layout7,
}

export { LookbookBlock }
